import { getCurrentInstance as getCurrentInstanceNuxt } from '@nuxtjs/composition-api';

/**
 * Should be avoided!!!
 */
export function getCurrentInstance() {
  return getCurrentInstanceNuxt().proxy;
}
